<template>
  <div class="wrap" v-loading.fullscreen.lock="loading">
    <div class="printWrap">
      <div class="pt40 pb40 clearfix filterGroup">
        <p class="fl">
          <span>Total</span>
          {{ getSelectedTotal }}
        </p>
        <div class="fr">
          <el-checkbox-group v-model="checkList">
            <el-checkbox v-for="(item, name) in invoiceTypeData" :key="`invoiceType-${item.title}`" :label="name">{{ item.title }}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="iframeWrap">
        <div v-for="item in invoiceInfoList" :key="`invoice-${item.invoiceNumber}`">
          <div v-show="checkList.includes(`${item.invoiceType}`)">
            <iframe
              :src="`${origin}/#/invoice?invoiceNo=${item.invoiceNumber}`"
              :id="`iframe-${item.invoiceNumber}`"
              width="100%"
              frameborder="0"
              allowfullscreen
              scrolling="no"
              class="invoice-iframe"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
export default {
  name: "BatchPrintInvoice",
  data() {
    return {
      loading: true,
      origin: "",
      orderId: "",
      invoiceInfoList: [],
      invoiceTypeData: {
        1: { title: "Invoice" },
        2: { title: "Credit Invoice" },
      },
      checkList: ["1", "2"],
      loadedIframeCount: 0,
    };
  },
  computed: {
    getSelectedTotal() {
      const list = this.invoiceInfoList.filter(item => this.checkList.includes(`${item.invoiceType}`));
      return list.length;
    },
  },
  methods: {
    // 获取发票详情
    getByInvoiceNoInfoList() {
      getAction("/customerInvoice/getAllInvoiceInfoListByOrderId", {
        orderId: this.orderId,
      })
        .then(res => {
          const resList = res.data || [];
          // 按照url参数中的顺序排序
          const orderIdList = this.orderId.split(",");
          const indexMap = new Map(orderIdList.map((id, index) => [id, index]));
          resList.sort((a, b) => indexMap.get(a.orderId) - indexMap.get(b.orderId));
          this.invoiceInfoList = resList;

          // 如果后端返回空数据，直接关闭 loading
          if (resList.length === 0) this.loading = false;
        })
        .catch(err => {
          this.loading = false;
        });
    },
    // 监听打印前事件
    handleBeforePrint() {
      // 隐藏打印按钮
      const filterGroup = document.querySelector(".filterGroup");
      if (filterGroup) filterGroup.style.display = "none";
    },
    // 监听打印后事件
    handleAfterPrint() {
      // 显示打印按钮
      const filterGroup = document.querySelector(".filterGroup");
      if (filterGroup) filterGroup.style.display = "block";
    },
    // 专门接收内部网页“渲染完毕”通知的方法
    handleChildInvoiceReady(event) {
      // 确保消息来自内部定义的通知
      if (event.data && event.data.type === "INVOICE_DATA_RENDERED") {
        const { invoiceNo } = event.data;

        // 根据发票号(:id="`iframe-${item.invoiceNumber}`")，精准找到对应的那个 iframe 标签
        const iframe = document.querySelector(`iframe[src*="invoiceNo=${invoiceNo}"]`);
        if (iframe) {
          try {
            const iframeDoc = iframe.contentWindow.document;
            // 此时内部数据已渲染成 DOM，算出来的绝对是真实完整的高度
            const realHeight = Math.max(iframeDoc.body.scrollHeight, iframeDoc.documentElement.scrollHeight);
            iframe.style.height = realHeight + "px";
          } catch (error) {
            console.error("计算发票高度失败:", error);
          }
        }

        // 计数器加一
        this.loadedIframeCount += 1;
        if (this.loadedIframeCount >= this.getSelectedTotal) {
          console.log("所有发票接口数据全部加载并撑开完毕！");
          this.loading = false;
        }
      }
    },
  },
  created() {
    // 获取域名
    this.origin = window.location.origin;

    // 检查url是否存在参数
    if (this.$route.query.orderId) {
      const orderId = this.$route.query.orderId;
      this.orderId = decodeURIComponent(orderId);
      // 获取发票详情
      this.getByInvoiceNoInfoList();
    } else {
      // 缺少参数
      this.$message({
        message: this.$t("common.error.scarce"),
        type: "error",
        duration: 1000,
        onClose: () => {
          // this.$router.replace({path: '/'})
        },
      });
    }
  },
  mounted() {
    // 监听打印前事件
    window.addEventListener("beforeprint", this.handleBeforePrint);
    // 监听打印后事件
    window.addEventListener("afterprint", this.handleAfterPrint);
    // 在父页面全局监听来自 iframe 的消息
    window.addEventListener("message", this.handleChildInvoiceReady);
  },
  beforeDestroy() {
    // 在组件销毁前移除事件监听器
    window.removeEventListener("beforeprint", this.handleBeforePrint);
    window.removeEventListener("afterprint", this.handleAfterPrint);
    window.removeEventListener("message", this.handleChildInvoiceReady);
  },
};
</script>

<style lang="scss" scoped>
.printWrap {
  width: 960px;
  margin: 0 auto;
}

.invoice-iframe {
  overflow: hidden !important;
  display: block; /* 消除行内元素的 3px 底部间隙 */
}

.iframeWrap {
  margin-top: -20px;
}
</style>
